import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Gera até 7 botões: primeiro, ..., (page-1), page, (page+1), ..., último.
function buildPages(page, totalPages) {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
  const pages = new Set([1, totalPages, page, page - 1, page + 1]);
  const sorted = Array.from(pages).filter((p) => p >= 1 && p <= totalPages).sort((a, b) => a - b);
  const withGaps = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) withGaps.push('…');
    withGaps.push(p);
  });
  return withGaps;
}

const Pagination = ({
  page = 1,
  pageSize = 20,
  total = 0,
  onPageChange,
  className = '',
}) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (totalPages <= 1) return null;

  const pages = buildPages(page, totalPages);
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);

  const goTo = (p) => {
    if (p < 1 || p > totalPages || p === page) return;
    onPageChange?.(p);
  };

  return (
    <div
      className={`flex items-center justify-between gap-4 flex-wrap ${className}`}
    >
      <p className="text-sm text-app-text-secondary">
        Mostrando <strong className="text-app-text">{start}</strong>–<strong className="text-app-text">{end}</strong> de{' '}
        <strong className="text-app-text">{total}</strong>
      </p>
      <nav aria-label="Paginação" className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => goTo(page - 1)}
          disabled={page <= 1}
          className="p-1.5 rounded-md text-app-text hover:bg-app-surface-hover disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          aria-label="Página anterior"
        >
          <ChevronLeft size={18} />
        </button>
        {pages.map((p, i) =>
          p === '…' ? (
            <span key={`gap-${i}`} className="px-2 text-app-text-secondary">
              …
            </span>
          ) : (
            <button
              key={p}
              type="button"
              onClick={() => goTo(p)}
              aria-current={p === page ? 'page' : undefined}
              className={`min-w-[2rem] h-8 px-2 rounded-md text-sm font-medium transition-colors ${
                p === page
                  ? 'bg-primary text-white'
                  : 'text-app-text hover:bg-app-surface-hover'
              }`}
            >
              {p}
            </button>
          )
        )}
        <button
          type="button"
          onClick={() => goTo(page + 1)}
          disabled={page >= totalPages}
          className="p-1.5 rounded-md text-app-text hover:bg-app-surface-hover disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          aria-label="Próxima página"
        >
          <ChevronRight size={18} />
        </button>
      </nav>
    </div>
  );
};

export default Pagination;
